import { faReceipt as faReceiptLight } from '@fortawesome/pro-light-svg-icons';
import { faGears } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppFeaturePlan } from '~/components/organisms/AppFeaturePlan';
import { AppPricingTable } from '~/components/organisms/AppPricingTable';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';

export type IAppSubscriptionSettingsPageProps = {
  appId: string;
};

export const AppSubscriptionSettingsPage: React.FC<
  IAppSubscriptionSettingsPageProps
> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppSubscriptionSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faReceiptLight} />}
        title={t('AppSubscriptionSettingsPage.title')}
        subtitle={t('AppSubscriptionSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />

      <AppPricingTable appId={appId} />
      <AppFeaturePlan appId={appId} />
    </>
  );
};
